import React from 'react'
import ReactDOM from 'react-dom'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { FeatureStateSymbol, Fetch, IFetchApi } from '@wix/thunderbolt-symbols'
import type { IConcreteExternalComponentLoader } from '../types'
import { name } from '../symbols'
import { IFeatureState } from 'thunderbolt-feature-state'
import { prepareTrustedComponent } from '../components/TrustedComponent'
import {
	loadUmdModule,
	fetchWithTimeoutRetries,
	ExternalComponentFileNotFoundError,
} from '@wix/external-component-renderer'

type ModuleEntries = { [namedExport: string]: React.ComponentType<any> }
type Modules = Map<string, Promise<ModuleEntries>>

export const TrustedExternalComponentLoader = withDependencies(
	[Fetch, named(FeatureStateSymbol, name)],
	(fetchApi: IFetchApi, featureState: IFeatureState<Modules>): IConcreteExternalComponentLoader => {
		if (!featureState.get()) {
			featureState.update(() => new Map())
		}
		const modules = featureState.get()

		const getModuleEntries = async (fullUrl: string, modulePath: string) => {
			const scriptContent = await fetchWithTimeoutRetries(fullUrl, modulePath, {
				fetchFn: fetchApi.envFetch,
			}).then((res) => res.text())

			// TODO temporary fix until the Velo bundler will return 404 for missing files
			if (!scriptContent) {
				throw new ExternalComponentFileNotFoundError(modulePath)
			}

			await window.externalsRegistry.react.loaded

			return loadUmdModule(
				scriptContent,
				modulePath,
				{ react: React, 'react-dom': ReactDOM },
				{ sourceUrl: modulePath }
			)
		}

		return {
			type: 'trusted',
			loadComponent: async ({ importKey, fullUrl, url, onError }) => {
				if (!modules.has(url)) {
					const modulePromise = getModuleEntries(fullUrl, url)
					modules.set(url, modulePromise)
				}

				const module = await modules.get(url)!

				return prepareTrustedComponent(module[importKey], onError)
			},
		}
	}
)
